export const COOKIE_STATUS_DETAILS = {
	ANALYTICAL: 'analytics_storage',
	MARKETING: 'ad_storage',
	FUNCTIONAL: 'functionality_storage',
	PERSONALIZATION: 'personalization_storage',
};

export const COOKIE_STATUS = {
	ALLOW: 'allow',
	DENAIED: 'denaied',
	NO_DECISION: 'no_decision',
	LOADING: 'loading',
};
